export enum UserRole {
  ADMIN = 'ADMIN',
  GESTOR = 'GESTOR',
  USER = 'USER',
  INTERNAL = 'INTERNAL_USER',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
}